<template>
  <v-btn
    class="scroll-top"
    data-aos="zoom-in-up"
    data-aos-offset="500"
    fixed
    fab
    dark
    color="teal"
    @click="sctollTop"
  >
    <v-icon dark>
      keyboard_arrow_up
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  methods: {
    sctollTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style lang="scss">
    .scroll-top {
        bottom: 50px;
        right: 16px;
        z-index: 10;

        @media(max-width: 960px) {
            opacity: 0.7 !important;
        }
    }
</style>
